export enum Language {
  Bokmal = 'nb-NO',
  Nynorsk = 'nn-NO',
  English = 'en'
}

export const SUPPORTED_LANGUAGES: Language[] = Object.values(Language);

export function isSupportedLanguage(language: string): language is Language {
  return SUPPORTED_LANGUAGES.includes(language as Language);
}
